// KpiCard — homepage metric card: label + value + optional trend (▲/▼ %). One
// of the "3–6 KPI metric cards" required by the Homepage screen type. Generic;
// used by Dashboard, Manage and Landing. Clickable when onClick is provided.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { Surface } from '../layout/Surface';
import './kpi-card.css';

function TrendBadge({ dir, pct }) {
  const arrow = dir === 'up' ? '▲' : dir === 'down' ? '▼' : '–';
  return (
    <span className={cx('kpi-card__trend', `kpi-card__trend--${dir}`)}>
      <span aria-hidden="true">{arrow}</span> {pct}
    </span>
  );
}
TrendBadge.propTypes = { dir: PropTypes.oneOf(['up', 'down', 'flat']), pct: PropTypes.node };

export function KpiCard({ label, value, trend, icon, tone = 'neutral', onClick, className }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Surface
      as={Tag}
      interactive={!!onClick}
      padding="md"
      className={cx('kpi-card', `kpi-card--${tone}`, className)}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      <div className="kpi-card__top">
        <span className="kpi-card__label">{label}</span>
        {icon && <span className="kpi-card__icon">{icon}</span>}
      </div>
      <div className="kpi-card__value">{value}</div>
      {trend && <TrendBadge dir={trend.dir} pct={trend.pct} />}
    </Surface>
  );
}

KpiCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  /** { dir: 'up'|'down'|'flat', pct: '8.4%' } */
  trend: PropTypes.shape({ dir: PropTypes.string, pct: PropTypes.node }),
  icon: PropTypes.node,
  tone: PropTypes.oneOf(['neutral', 'primary', 'success', 'warning', 'danger', 'purple']),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default KpiCard;
